import { render, staticRenderFns } from "./overlay-header.vue?vue&type=template&id=62b908ff&scoped=true"
import script from "./overlay-header.vue?vue&type=script&lang=js"
export * from "./overlay-header.vue?vue&type=script&lang=js"
import style0 from "./overlay-header.vue?vue&type=style&index=0&id=62b908ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b908ff",
  null
  
)

export default component.exports